import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  text: 'Ich war skeptisch, aber nach 2 Wochen hatte Balu zum ersten Mal wieder normalen Stuhl. Wir sind so erleichtert.',
  author: 'Sandra (Hund: Balu, Labrador, 4 Jahre)',
  avatar: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&q=80&w=100&h=100'
}, {
  text: 'Luna hatte wochenlang wechselhaften Stuhl und war total unruhig. Nach dem Topping hat sich das innerhalb von 10 Tagen komplett gelegt.',
  author: 'Michael (Hund: Luna, Schäferhund-Mix, 6 Jahre)',
  avatar: 'https://images.unsplash.com/photo-1589941013453-ec89f33b5e95?auto=format&fit=crop&q=80&w=100&h=100'
}, {
  text: 'Wir haben so viel probiert wegen seiner gestörten Darmflora. Das Topping ist das erste, was wirklich nachhaltig geholfen hat. Oskars Bauch ist endlich ruhig.',
  author: 'Julia (Hund: Oskar, Golden Retriever, 6 Jahre)',
  avatar: 'https://images.unsplash.com/photo-1633722715463-d30f4f325e24?auto=format&fit=crop&q=80&w=100&h=100'
}];
export function Testimonials() {
  return <section className="w-full px-4 py-12 bg-white/40 border-y border-brown/10" data-id="element-143">
      <div className="max-w-3xl mx-auto" data-id="element-144">
        <h3 className="font-handwriting text-4xl text-forest font-bold text-center mb-10" data-id="element-145">
          Das sagen andere Hundeeltern
        </h3>

        <div className="grid gap-6 md:grid-cols-1" data-id="element-146">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col gap-4" data-id="element-147">
              <div className="flex items-center justify-between" data-id="element-148">
                <div className="flex gap-1 text-yellow-500" data-id="element-149">
                  {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" className="text-yellow-400" data-id="element-150" />)}
                </div>
                <span className="text-xs text-gray-400 font-sans" data-id="element-151">
                  Verifizierter Kauf
                </span>
              </div>

              <p className="font-serif text-gray-800 text-lg leading-relaxed" data-id="element-152">
                {review.text}
              </p>

              <div className="flex items-center gap-3 mt-2" data-id="element-153">
                <img src={review.avatar} alt="" className="w-10 h-10 rounded-full object-cover" data-id="element-154" />
                <p className="font-sans font-medium text-gray-900 text-sm" data-id="element-155">
                  {review.author}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}